import { read_u16, read_u32, read_u64, Sink } from "../../helpers/serializerHelpers";

export class FrameHeader {
    public sync: bigint = BigInt(0);
    public version: number = 0;
    public platform: number = 0;
    public timestamp: number = 0; // 200MHz clocks
    public packetLength: number = 0;
    public frameNumber: number = 0; //Starting at 1
    public subFrameNumber: number = 0;
    public chirpMargin: number = 0; //Chirp Processing margin in ms
    public frameMargin: number = 0; //Frame processing margin in ms
    public trackProcessTime: number = 0; //Tracking processing time in ms
    public uartSentTime: number = 0; //Time spent to send data in ms
    public numTLVs: number = 0; //Number of TLVs in thins frame
    public checksum: number = 0; //Header checksum

    public deserialize(bytes: Sink) {
        if (bytes.view.byteLength - bytes.pos < this.getLength()) return this;

        this.sync = read_u64(bytes);

        this.version = read_u32(bytes);
        this.platform = read_u32(bytes);
        this.timestamp = read_u32(bytes); // 200MHz clocks
        this.packetLength = read_u32(bytes);
        this.frameNumber = read_u32(bytes); //Starting at 1
        this.subFrameNumber = read_u32(bytes);
        this.chirpMargin = read_u32(bytes); //Chirp Processing margin in ms
        this.frameMargin = read_u32(bytes); //Frame processing margin in ms
        this.trackProcessTime = read_u32(bytes); //Tracking processing time in ms
        this.uartSentTime = read_u32(bytes); //Time spent to send data in ms

        this.numTLVs = read_u16(bytes); //Number of TLVs in thins frame
        this.checksum = read_u16(bytes);; //Header checksum
        return this;
    }

    getLength() {
        return 8 + 4 * 10 + 2 * 2;
    }
}